/** Кнопка «без звука»: справа сверху под прочностью штаба; на десктопе — первая строка правой колонки. Состояние — `audioSettings` (localStorage). */
import { useStore, useT } from "../app/hooks";
import { addMessages } from "../i18n";
import { audioMessages } from "./messages";
import { audioSettings, toggleMuted } from "./settings";
import "./audio.css";

addMessages(audioMessages);

export function SoundToggle() {
  const muted = useStore(audioSettings, (s) => s.muted);
  const t = useT();
  const label = t(muted ? "audio.unmute" : "audio.mute");
  return (
    <button
      type="button"
      class="sound-toggle"
      data-testid="sound-toggle"
      data-muted={muted ? "1" : "0"}
      aria-pressed={muted}
      aria-label={label}
      title={label}
      onClick={() => toggleMuted()}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="currentColor">
        <path d="M3 9v6h4l5 4V5L7 9H3z" />
        {muted ? (
          <path d="M15 9l6 6m0-6l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
        ) : (
          <path
            d="M15.5 8.5a5 5 0 010 7M18 6a8.5 8.5 0 010 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            fill="none"
          />
        )}
      </svg>
    </button>
  );
}
